import React from 'react';
import PressPresenter from "./PressPresenter";
import { useParams, useNavigate } from 'react-router-dom';

import { useScrollTop } from '../../hooks';
import { press } from '../../api';

// TODO: REMOVED
import pressDetailImage from '../../images/press/press_detail.png'

const pressInitState = [
  { 
    id: 1, 
    date: '2024.08.08.', 
    // title: '박성웅·연우·김지영·이수경, KBS 새 드라마 ‘개소리’ 출연 타이틀 타이틀 타이틀 타이틀 길면 최대 2줄까지 노출',
    title: '박성웅·연우·김지영·이수경, KBS 새 드라마 ‘개소리’ 출연 타이틀 타이틀 타이틀 타이틀 길면 최대 2줄까지 노출 박성웅·연우·김지영·이수경, KBS 새 드라마 ‘개소리’ 출연 타이틀 타이틀 타이틀 타이틀 길면 최대 2줄까지 노출 박성웅·연우·김지영·이수경, KBS 새 드라마 ‘개소리’ 출연 타이틀 타이틀 타이틀 타이틀 길면 최대 2줄까지 노출',
    // content: "배우 박성웅과 연우, 김지영, 이수경이 KBS2 새 수목드라마 '개소리'에 출연한다. 오는 9월 첫 방송 예정인 '개소리'(극본 변숙경, 연출 김유진)는 활약 만점 시니어들과 경찰견 출신..." 
    content: "배우 박성웅과 연우, 김지영, 이수경이 KBS2 새 수목드라마 '개소리'에 출연한다. 오는 9월 첫 방송 예정인 '개소리'(극본 변숙경, 연출 김유진)는 활약 만점 시니어들과 경찰견 출신 KBS2 새 수목드라마 '개소리'에 출연한다. 오는 9월 첫 방송 예정인 '개소리'(극본 변숙경, 연출 김유진)는 활약 만점 시니어들과 경찰견 출신...",
    image: pressDetailImage,
  },
  { id: 2, date: '2024.08.08.', title: "오윤아·예지원·이수경, 공개 연애 선언…‘여배우의 사생활’ 20일 첫방", content: "예지원, 오윤아, 이수경이 공개 연애를 예고했다. 오는 20일 오후 10시 첫 방송되는 TV CHOSUN 신규 예능, 여배우들의 아주 사적인 연애 스토리 ’...", image: '' },
  { id: 3, date: '2024.08.08.', title: "'신발 벗고 돌싱포맨' '타짜'의 그녀…배우 이수경 깜짝 출연", content: "배우 이수경(본명 이나원)이 SBS 예능 '신발 벗고 돌싱포맨'에 출연하면서 근황을 전했다. 지난 2일 방송된 144회에서는 올해 결혼을 목표로 하는 임원희, 이상민, 탁재훈의 리얼 데이팅 연애 …", image: '' },
];
const countInitState = 0;

const PressContainer = () => {
  const navigate = useNavigate();
  const { page } = useParams();

  const currentPage = React.useMemo(() => {
    const pageNumber = parseInt(page, 10) || 1;
    return pageNumber > 0 ? pageNumber : 1;
  }, [page]);

  const [press, setPress] = React.useState(pressInitState);
  const [count, setCount] = React.useState(countInitState);

  const navigateToPressDetail = (id) => {
    navigate(`/press/detail/${id}`);
  };

  const onPageChange = (newPage) => {
    navigate(`/press/page/${newPage.selected + 1}`);
  };

  const getPress = async () => {
    try {
      const response = await press.getPress(currentPage);
      setPress(response.data.press);
      setCount(response.data.count);
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    // getPress();
  }, [currentPage]);

  useScrollTop();

  return (
    <PressPresenter 
      press={press} 
      count={count} 
      currentPage={currentPage}
      onPageChange={onPageChange}
      navigateToPressDetail={navigateToPressDetail}
    />
  );
};

export default PressContainer;
